import { Pipe, PipeTransform } from '@angular/core';
import { I18NextPipe } from 'angular-i18next';

@Pipe({
  name: 'i18n',
})
export class I18nPipe extends I18NextPipe implements PipeTransform {}
